// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_hr-0";
export var animationContainer = "_hr-1";
export var itemPrice = "_hr-a";
export var itemizedContent = "_hr-9";
export var itemizedHeader = "_hr-7";
export var itemizedRow = "_hr-8";
export var itemizedSection = "_hr-6";
export var modalContent = "_hr-2";
export var orderName = "_hr-3";
export var refundOption = "_hr-4";
export var refundOptionsContainer = "_hr-5";
export var shippingLabel = "_hr-b";
export var totalRow = "_hr-c";